import React from 'react';

import { Button } from '@travelnest/merlin.button';
import theme from '@travelnest/merlin.theme';
import { ICalendarSource } from '../../../data/entities/calendar-source';
import { Character } from '../../constants';
import { CalendarSourceSyncStatus } from './CalendarSourceSyncStatus';

interface ICalendarSourceDisplayBlockProps {
	calendarSource: ICalendarSource;
	onRemoveClick: (source: ICalendarSource) => any;
}

export const CalendarSourceDisplayBlock: React.FC<ICalendarSourceDisplayBlockProps> = ({ calendarSource, onRemoveClick }) => {
	const [trayOpen, setTrayOpen] = React.useState(false);

	return <>
		<div className="calendar-source-display__container">
			<div className="calendar-source-display__content">
				<h3>{calendarSource.name || calendarSource.source}</h3>
				<CalendarSourceSyncStatus calendarSource={calendarSource} />
			</div>
			<div className="calendar-source-display__tray-toggle">
				<div
					className="calendar-source-display__tray-toggle-icon"
					onClick={() => setTrayOpen(!trayOpen)}>
					{trayOpen ? Character.Up : Character.Down}
				</div>
			</div>
		</div>
		{trayOpen && <div className="calendar-source-display__tray">
			<Button
				id={`calendar-source-display__remove_button-${calendarSource.id}`}
				className="calendar-source-display__remove_button"
				bgColor={theme.colours.background.default}
				onClick={() => onRemoveClick(calendarSource)}
			>
				<span>Remove calendar</span>
			</Button>
		</div>}
	</>;
};
